<template>
  <div>
    <div style="margin-bottom:20px;">
      <h3>主体失信</h3>
      <Table
        :labelListObj="mainDiscreditObj"
        firstKeyName="defaultLoanList"
      ></Table>
    </div>

    <div style="margin-bottom:20px;">
      <h3>担保失信</h3>
      <Table
        :labelListObj="guaranteeDiscreditObj"
        firstKeyName="guaranteeDiscreditList"
      ></Table>
    </div>

    <div style="margin-bottom:20px;">
      <h3>关联失信</h3>
      <Table
        :labelListObj="relationDiscreditObj"
        firstKeyName="relationDiscreditList"
      ></Table>
    </div>
  </div>
</template>
<script>
import { getMonitorEnterpriseDiscreditInfo } from './api'
import Table from './components/table'
export default {
  data() {
    const labelObjToObj = function(keyLabelObj) {
      const result = {}
      Object.keys(keyLabelObj).map(key => {
        result[key] = {}
        result[key].label = keyLabelObj[key]
        result[key].list = []
      })
      return result
    }
    const mainLabelObj = {
      defaultLoanList: '拖欠借款',
      defaultCreditList: '拖欠贷款',
      executorList: '被执行人',
      discreditExecutorList: '失信被执行人(次)',
    }

    const guaranteeLabelObj = {
      guaranteeDiscreditList: '对外担保',
    }

    const relationLabelObj = {
      relationDiscreditList: '关联企业债务',
    }

    // 将mainDiscreditObj的数据结构转成 {defaultLoanList: {label: '', list}...}的形式
    const mainDiscreditObj = labelObjToObj(mainLabelObj)
    const guaranteeDiscreditObj = labelObjToObj(guaranteeLabelObj)
    const relationDiscreditObj = labelObjToObj(relationLabelObj)

    return {
      mainDiscreditObj, // 主体失信
      guaranteeDiscreditObj, // 担保企业失信信息
      relationDiscreditObj, // 关联企业失信信息
    }
  },
  async mounted() {
    const params = {
      enterpriseName: this.$store.getters['app/company'].name,
      // enterpriseName: '合肥胜利精密科技有限公司'
    }
    const {
      resultData: { mainDiscredit, guaranteeDiscredit, relationDiscredit },
    } = await getMonitorEnterpriseDiscreditInfo(params)
    if (mainDiscredit && guaranteeDiscredit && relationDiscredit) {
      this.resultDataToLabelListObj(mainDiscredit, 'mainDiscreditObj')
      this.resultDataToLabelListObj(guaranteeDiscredit, 'guaranteeDiscreditObj')
      this.resultDataToLabelListObj(relationDiscredit, 'relationDiscreditObj')
    }
  },
  methods: {
    resultDataToLabelListObj(resultData, dataKeyName) {
      Object.keys(resultData).map(key => {
        const value = resultData[key]
        if (this[dataKeyName][key]) {
          this[dataKeyName][key].list = value
        }
      })
    },
  },
  components: {
    Table,
  },
}
</script>

<style lang="less" scoped>
.custom-table {
  width: 100%;
  max-width: 100%;
  min-width: 580px;
  text-align: center;
  border-left: 1px solid #e8e8e8;
  border-top: 1px solid #e8e8e8;
  overflow: hidden;
  margin: 0 auto;
  table-layout: fixed;
  tr th:first-child,
  tr td:first-child {
    width: 150px;
  }
  thead tr {
    background-color: #fafafa;
    color: #333339;
    height: 36px;
    line-height: 36px;
  }
  .th-split {
    position: relative;
    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 109px;
      height: 1px;
      background: #e8e8e8;
      transform: scaleX(1.5) rotate(20deg);
    }
  }
  .ab-class-pane {
    position: absolute;
    bottom: -6px;
    left: 15px;
  }
  .ab-limit-pane {
    position: absolute;
    top: -6px;
    right: 12px;
  }
  tbody td,
  thead th {
    border-right: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
  }
}
</style>
